import React from "react";
import AddNews from "../../Administrative/AddNews";

const AddYuvasarthiNews = () => {
  return (
    <div>
      <AddNews role="Super Admin" />
    </div>
  );
};

export default AddYuvasarthiNews;
